import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: row;
  justify-content: space-between;
  height: 500px;
  @media (max-width: 820px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Main = styled.div`
  flex: 4;
  align-content: space-between;
  @media (max-width: 820px) {
  }
`;

export const Aside = styled.div`
  flex: 2;
  gap: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 820px) {
    flex-direction: row;
    gap: 10px;
  }
`;
